<template>
    <div class="end-intervention">
        <div class="wrap">
            <label>Nom Detenteur</label>
            <input title="name" type="text" class="dossier" name="_det_nom" id="_det_nom" v-model="infosDet.nom_signataire" @input="updateIsValid" maxlength="255">
            <label>Fonction</label>
            <input title="function" type="text" class="dossier" name="_det_qualite" id="visa_det_qualite" v-model="infosDet.fonction_signataire" @input="updateIsValid" maxlength="255">
        </div>
    </div>
</template>

<script>
    import SignatureModal from '../../../common/SignatureModal.vue'

    export default {

        data() {
            return {
                showModal: false,
                isValid: null
            }
        },

        props: {
            infosDet: {
                nom_signataire: null,
                fonction_signataire: null
            },
        },

        methods: {

            updateIsValid() {


                this.isValid = !!(this.infosDet.nom_signataire && this.infosDet.fonction_signataire);

                this.$emit('infosDetUpdated', this.isValid)

                /*
                if( !this.infosDet.nom_signataire || !this.infosDet.fonction_signataire){
                    this.isValid = false;
                    document.getElementById('goto-finish').classList.remove('actif')
                } else {
                    this.isValid = true;
                    document.getElementById('goto-finish').classList.add('actif')
                }
                this.$emit('infosDetUpdated', this.isValid)
                }
                 */
            }

        },

        components: {
            SignatureModal
        }

    }
</script>



// WEBPACK FOOTER //
// ClientInfos.vue?515c5e0d